import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vModelText as _vModelText, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-[#23242A] text-white px-8 pb-48 h-screen overflow-y-auto" }
const _hoisted_2 = { class: "p-3 flex content-main gap-5" }
const _hoisted_3 = { class: "custom-full" }
const _hoisted_4 = { class: "bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5" }
const _hoisted_5 = {
  key: 1,
  class: "bg-[#2B2C32] rounded-lg mt-1 pt-1 pb-5"
}
const _hoisted_6 = { class: "flex justify-between mb-3" }
const _hoisted_7 = { class: "flex items-center cursor-pointer" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "ml-2 max-w-[760px]" }
const _hoisted_10 = { class: "admin-table py-4" }
const _hoisted_11 = { class: "cursor-pointer text-sm" }
const _hoisted_12 = { class: "admin-table border-t-[2px] border-field-black py-4" }
const _hoisted_13 = { class: "cursor-pointer text-sm" }
const _hoisted_14 = { class: "ml-7 flex flex-col gap-5 relative" }
const _hoisted_15 = {
  key: 0,
  class: "absolute top-0 left-0 w-full bg-[#2b2c31] h-full opacity-40"
}
const _hoisted_16 = { class: "flex flex-col gap-1" }
const _hoisted_17 = ["textContent"]
const _hoisted_18 = { class: "flex flex-col gap-1" }
const _hoisted_19 = ["textContent"]
const _hoisted_20 = { class: "flex flex-col gap-1" }
const _hoisted_21 = ["onkeypress"]
const _hoisted_22 = ["textContent"]
const _hoisted_23 = { class: "flex flex-col gap-1" }
const _hoisted_24 = ["textContent"]
const _hoisted_25 = { class: "mt-10" }
const _hoisted_26 = { class: "admin-table mt-2" }
const _hoisted_27 = { class: "flex items-center cursor-pointer" }
const _hoisted_28 = { class: "mt-10" }
const _hoisted_29 = { class: "admin-table mt-2" }
const _hoisted_30 = { class: "flex items-center cursor-pointer" }
const _hoisted_31 = { class: "mt-10" }
const _hoisted_32 = { class: "admin-table mt-2" }
const _hoisted_33 = { class: "cursor-pointer text-sm" }
const _hoisted_34 = { class: "admin-table mt-2" }
const _hoisted_35 = { class: "cursor-pointer text-sm" }
const _hoisted_36 = { class: "admin-table mt-2" }
const _hoisted_37 = { class: "cursor-pointer text-sm" }
const _hoisted_38 = {
  key: 1,
  class: "text-center text-theme-red"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_block_loading = _resolveComponent("block-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.vg_selectedLocation.id)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_Nav),
              _createElementVNode("div", _hoisted_4, [
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_block_loading, { key: 0 }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_7, [
                            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-[20px] mr-4 text-grey" }, "Delivery", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.deliveryActive) = $event)),
                              class: "hidden peer"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.form.deliveryActive]
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (_ctx.form.deliveryActive ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
                            }, null, 2),
                            _createElementVNode("span", {
                              class: _normalizeClass(["ml-2 text-white text-sm font-medium uppercase", _ctx.form.deliveryActive ? 'text-theme-green' : 'text-[#F53333]'])
                            }, _toDisplayString(_ctx.form.deliveryActive ? 'On' : 'Off'), 3)
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("button", {
                            disabled: _ctx.isInvalidToSave(),
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save())),
                            class: "h-10 hover:bg-theme-green disabled:bg-theme-grey disabled:cursor-default disabled:text-theme-green border-0 hover:text-white rounded-[4px] cursor-pointer text-theme-green bg-white py-2 px-4 uppercase"
                          }, "Save", 8, _hoisted_8)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[37] || (_cache[37] = _createElementVNode("div", { class: "text-sm" }, "Ordering Options:", -1)),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("label", _hoisted_11, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                value: "1",
                                class: "mr-3",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.enableAsap) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.form.enableAsap]
                              ]),
                              _cache[18] || (_cache[18] = _createTextVNode("ASAP ", -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("label", _hoisted_13, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                value: "1",
                                class: "mr-3",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.deliveryTimeSlots) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.form.deliveryTimeSlots]
                              ]),
                              _cache[19] || (_cache[19] = _createTextVNode("Scheduled Ordering ", -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            (_ctx.form.deliveryTimeSlots == false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_16, [
                              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-sm" }, "Time Slots", -1)),
                              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-sm text-grey" }, "Select the length of the time slot the customer can choose.", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass('input-wrapper max-w-[260px] ' + (_ctx.form.timeSlotDuration.error_type))
                              }, [
                                _withDirectives(_createElementVNode("select", {
                                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateFields(['timeSlotDuration']))),
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.timeSlotDuration.value) = $event)),
                                  class: "border-none block rounded bg-gray-black w-full text-sm"
                                }, [...(_cache[20] || (_cache[20] = [
                                  _createStaticVNode("<option value=\"\">-- Select --</option><option value=\"15\">15 minutes interval</option><option value=\"30\">30 minutes interval</option><option value=\"45\">45 minutes interval</option><option value=\"60\">60 minutes interval</option><option value=\"90\">90 minutes interval</option><option value=\"120\">120 minutes interval</option>", 7)
                                ]))], 544), [
                                  [
                                    _vModelSelect,
                                    _ctx.form.timeSlotDuration.value,
                                    void 0,
                                    { number: true }
                                  ]
                                ]),
                                (_ctx.form.timeSlotDuration.error_message)
                                  ? (_openBlock(), _createElementBlock("p", {
                                      key: 0,
                                      class: "field-error label-text mt-1",
                                      textContent: _toDisplayString(_ctx.form.timeSlotDuration.error_message)
                                    }, null, 8, _hoisted_17))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-sm" }, "Order Prep Time", -1)),
                              _cache[25] || (_cache[25] = _createElementVNode("div", { class: "text-sm text-grey" }, "How long does it take your staff to prepare orders for pickup. This setting is used to prevent orders when time slots are full until they have been prepared.", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass('input-wrapper max-w-[260px] ' + (_ctx.form.orderPrepTime.error_type))
                              }, [
                                _withDirectives(_createElementVNode("select", {
                                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateFields(['orderPrepTime']))),
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.orderPrepTime.value) = $event)),
                                  class: "border-none block rounded bg-gray-black w-full text-sm"
                                }, [...(_cache[23] || (_cache[23] = [
                                  _createStaticVNode("<option value=\"\">-- Select --</option><option value=\"15\">15 minutes interval</option><option value=\"30\">30 minutes interval</option><option value=\"45\">45 minutes interval</option><option value=\"60\">60 minutes interval</option><option value=\"90\">90 minutes interval</option><option value=\"120\">120 minutes interval</option>", 7)
                                ]))], 544), [
                                  [
                                    _vModelSelect,
                                    _ctx.form.orderPrepTime.value,
                                    void 0,
                                    { number: true }
                                  ]
                                ]),
                                (_ctx.form.orderPrepTime.error_message)
                                  ? (_openBlock(), _createElementBlock("p", {
                                      key: 0,
                                      class: "field-error label-text mt-1",
                                      textContent: _toDisplayString(_ctx.form.orderPrepTime.error_message)
                                    }, null, 8, _hoisted_19))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "text-sm" }, "Orders Per Timeslot", -1)),
                              _cache[27] || (_cache[27] = _createElementVNode("div", { class: "text-sm text-grey" }, "Max number of orders that can be placed in each timeslot to control the flow of your orders.", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass('input-wrapper ' + (_ctx.form.orderLimitPerTimeSlot.error_type))
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  onkeypress: _ctx.preventNonNumbers,
                                  onKeyup: _cache[8] || (_cache[8] = ($event: any) => (_ctx.validateFields(['orderLimitPerTimeSlot']))),
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.orderLimitPerTimeSlot.value) = $event)),
                                  class: "max-w-[260px] placeholder-white block bg-gray-black w-full text-sm text-white rounded border-none",
                                  type: "number"
                                }, null, 40, _hoisted_21), [
                                  [
                                    _vModelText,
                                    _ctx.form.orderLimitPerTimeSlot.value,
                                    void 0,
                                    { number: true }
                                  ]
                                ]),
                                (_ctx.form.orderLimitPerTimeSlot.error_message)
                                  ? (_openBlock(), _createElementBlock("p", {
                                      key: 0,
                                      class: "field-error label-text mt-1",
                                      textContent: _toDisplayString(_ctx.form.orderLimitPerTimeSlot.error_message)
                                    }, null, 8, _hoisted_22))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "text-sm" }, "Advanced Ordering", -1)),
                              _cache[30] || (_cache[30] = _createElementVNode("div", { class: "text-sm text-grey" }, "Only allow to set 3 days in advance.", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass('input-wrapper max-w-[260px] ' + (_ctx.form.timeSlotPeriod.error_type))
                              }, [
                                _withDirectives(_createElementVNode("select", {
                                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.validateFields(['timeSlotPeriod']))),
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.timeSlotPeriod.value) = $event)),
                                  class: "border-none block rounded bg-gray-black w-full text-sm"
                                }, [...(_cache[28] || (_cache[28] = [
                                  _createElementVNode("option", { value: "" }, "-- Select --", -1),
                                  _createElementVNode("option", { value: "1" }, "1 day", -1),
                                  _createElementVNode("option", { value: "2" }, "2 days", -1),
                                  _createElementVNode("option", { value: "3" }, "3 days", -1)
                                ]))], 544), [
                                  [
                                    _vModelSelect,
                                    _ctx.form.timeSlotPeriod.value,
                                    void 0,
                                    { number: true }
                                  ]
                                ]),
                                (_ctx.form.timeSlotPeriod.error_message)
                                  ? (_openBlock(), _createElementBlock("p", {
                                      key: 0,
                                      class: "field-error label-text mt-1",
                                      textContent: _toDisplayString(_ctx.form.timeSlotPeriod.error_message)
                                    }, null, 8, _hoisted_24))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "text-sm" }, "After Hours Ordering:", -1)),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("label", _hoisted_27, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.afterHoursOrdering) = $event)),
                                  class: "hidden peer"
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.form.afterHoursOrdering]
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (_ctx.form.afterHoursOrdering ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
                                }, null, 2),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["ml-2 text-white text-sm font-medium uppercase", _ctx.form.afterHoursOrdering ? 'text-theme-green' : 'text-[#F53333]'])
                                }, _toDisplayString(_ctx.form.afterHoursOrdering ? 'On' : 'Off'), 3)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _cache[32] || (_cache[32] = _createElementVNode("div", { class: "text-sm" }, "Enable/Disable Tips:", -1)),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("label", _hoisted_30, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.enableTips) = $event)),
                                  class: "hidden peer"
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.form.enableTips]
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (_ctx.form.enableTips ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
                                }, null, 2),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["ml-2 text-white text-sm font-medium uppercase", _ctx.form.enableTips ? 'text-theme-green' : 'text-[#F53333]'])
                                }, _toDisplayString(_ctx.form.enableTips ? 'On' : 'Off'), 3)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _cache[36] || (_cache[36] = _createElementVNode("div", { class: "text-sm" }, "Payment Methods Displayed to Customer", -1)),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("label", _hoisted_33, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  value: "1",
                                  class: "mr-3",
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.payOnline) = $event))
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.form.payOnline]
                                ]),
                                _cache[33] || (_cache[33] = _createTextVNode("Pay Online ", -1))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("label", _hoisted_35, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  value: "1",
                                  class: "mr-3",
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.payAtDoorCc) = $event))
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.form.payAtDoorCc]
                                ]),
                                _cache[34] || (_cache[34] = _createTextVNode("At the door - Debit & Credit ", -1))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("label", _hoisted_37, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  value: "1",
                                  class: "mr-3",
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.payAtDoorCash) = $event))
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.form.payAtDoorCash]
                                ]),
                                _cache[35] || (_cache[35] = _createTextVNode("At the door - Cash ", -1))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("p", _hoisted_38, "Please select a location from the top left corner."))
      ])
    ])
  ]))
}